import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import { CircularProgress, Tooltip } from '@mui/material';

import type { ExecutionLog } from '@/types';

import { getExecutionStatus } from '../utils/executionStatus';

interface ExecutionStatusIconProps {
  execution: ExecutionLog;
  size?: number;
}

/**
 * Reusable execution status icon component
 * Shows appropriate icon based on execution state with tooltip
 */
export const ExecutionStatusIcon = ({ execution, size = 16 }: ExecutionStatusIconProps) => {
  const { status, tooltip, color } = getExecutionStatus(execution);

  if (status === 'running') {
    return (
      <Tooltip title={tooltip}>
        <CircularProgress size={size} />
      </Tooltip>
    );
  }

  if (status === 'partial') {
    return (
      <Tooltip title={tooltip}>
        <WarningIcon sx={{ fontSize: size, color: `${color}.main` }} />
      </Tooltip>
    );
  }

  if (status === 'success') {
    return (
      <Tooltip title={tooltip}>
        <CheckCircleIcon sx={{ fontSize: size, color: `${color}.main` }} />
      </Tooltip>
    );
  }

  // Failed
  return (
    <Tooltip title={tooltip}>
      <ErrorIcon sx={{ fontSize: size, color: `${color}.main` }} />
    </Tooltip>
  );
};
